module.exports = __webpack_public_path__ + "d564b38434b2c7ebe9b2f7878d6ef79a.svg";